import { renderModel } from '../../util/renderModel';
import { biLogger } from '../biLogger';
import { BiEventLogger } from '../types';

type HelpmatePanelSuggestedQuestionClickBiData = {
  clickedText: string;
  clickedItemOrder: number;
};

export const logHelpmatePanelSuggestedQuestionClick: BiEventLogger<
  HelpmatePanelSuggestedQuestionClickBiData
> = async (state, { clickedText, clickedItemOrder }) => {
  await biLogger.pageClick(state, {
    clicked_item_type: 'helpmate_panel_suggested_question_click',
    source_name: 'article',
    kb_lang: renderModel.getLocale(),
    clicked_text: clickedText,
    clicked_item_order: String(clickedItemOrder),
  });
};
